/**
 * Created by dv on 7/11/2017.
 */
import {
  CollectionMetadataValueObj,
  CreateZmCollectionMessage,
  CreateZmCollectionQuery,
  FuidRrnInfo,
  ZmCollection
} from '../../../autogenerated/ZoomBridge';

/**
 * Class can be used to create or edit basic infomration of collection.
 */
export default class CreateCollection {
  /**
   * @param  {string} name Name of the collection
   */
  constructor(name) {
    /**
     * @type {ZmCollection}
     * @private
     */
    this._zmCollection = new ZmCollection().setName(name);
    /**
     * @type {Array.<FuidRrnInfo>}
     * @private
     */
    this.fuidBidRrns = [];

    /**
     * @type {Array<CollectionMetadataValueObj>}
     * @private
     */
    this._metadataValues = null;
    /**
     * @type {Array<String>}
     * @private
     */
    this._metadataProps = null;
  }

  /**
   * Appends the fuid, bid, rrn to internal fuid bid rrns list.
   * @param {Number} fuid
   * @param {Number} bid
   * @param {Number} rrn
   * @returns {CreateCollection}
   * @public
   */
  append(fuid, bid, rrn) {
    const fuidBidRrn = new FuidRrnInfo();
    fuidBidRrn
      .setBid(bid)
      .setFuid(fuid)
      .setRrn(rrn);
    this.fuidBidRrns.push(fuidBidRrn);
    return this;
  }

  /**
   * @param  {Array.<FuidRrnInfo>} fuidRrnList
   * @returns {CreateCollection}
   */
  setFuidRrnList(fuidRrnList) {
    this.fuidBidRrns = fuidRrnList;
    return this;
  }

  set zmCollection(value) {
    this._zmCollection = value;
  }

  /**
   * @param {Array<CollectionMetadataValueObj>}
   */
  setMetadataValues(value: Array<CollectionMetadataValueObj>) {
    this._metadataValues = value;
  }

  /**
   * @param {Array<String>}
   */
  setMetadataProps(propValue: Array<String>) {
    this._metadataProps = propValue;
  }

  /**
   *
   * Returns the collection id on success. Else ErrorId.
   * @return {Promise.<Number,ErrorId>}
   */
  run() {
    return new Promise((onSuccess, onFailure) => {
      const query = new CreateZmCollectionQuery();
      const msg = new CreateZmCollectionMessage();
      this._zmCollection.setUseLatestRevisionOfAssets(true);
      this._zmCollection.setDynamic(true);
      if (this._metadataProps) {
        msg.setMetadataProps(this._metadataProps);
      }
      if (this._metadataValues) {
        msg.setMetadataValues(this._metadataValues);
      }
      msg.setZmCollection(this._zmCollection);
      if (this.fuidBidRrns.length) msg.setFuidRrnList(this.fuidBidRrns);
      query.message = msg;
      query.run().then(
        (resp) => {
          if (onSuccess) onSuccess(resp);
        },
        (failedResp) => {
          if (onFailure) onFailure(failedResp);
        }
      );
    });
  }

  static test() {
    new CreateCollection('XyzCollection');
  }
}
